<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-archive'></i> Draw</h3>
          <!-- <b-button variant="primary" class="float-right" @click="showModal">Create Draw</b-button> -->
      </b-card-header>
      <b-card-body>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <!-- <template v-slot:cell(action)="data">
            <b-button variant="warning" @click="editDraw(data.item.Id)">Edit</b-button>
          </template> -->
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>
    <!-- <b-modal ref="editDraw" size="lg" header-bg-variant="primary" hide-footer title="Edit Draw">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.eDrawName.$error && $v.eGiftList.$error && $v.eExpireDays.$error)">
                      <label for="eRuleName">Name</label>
                      <b-form-input type="text" id="eDrawName" placeholder="Enter Draw Name" v-model.trim="eDrawName" :state="$v.eDrawName.$error?false:null" @focus.native="$v.eDrawName.$touch"></b-form-input>
                      <div v-if="$v.eDrawName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eDrawName.required">Draw name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eDrawName.minLength">Must have at least {{ $v.eDrawName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eDrawName.maxLength">Must not exceed {{ $v.eDrawName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="eRuleDisplayName">Display Name</label>
                      <b-form-input type="text" id="eDrawDisplayName" placeholder="Enter Draw Display Name" v-model.trim="eDrawDisplayName" :state="$v.eDrawDisplayName.$error?false:null" @focus.native="$v.eDrawDisplayName.$touch"></b-form-input>
                      <div v-if="$v.eDrawDisplayName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eDrawDisplayName.required">Draw Display name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eDrawDisplayName.minLength">Must have at least {{ $v.eDrawDisplayName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eDrawDisplayName.maxLength">Must not exceed {{ $v.eDrawDisplayName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="eRuleList">Rule List</label>
                      <b-form-select id="eRuleList" :plain="false" v-model="eRuleList">
                        <option :value="null">Please select</option>
                        <option v-for="t in ruleLists" :value="t.Id" :key="`rule-list-${t.Id}`">{{ t.Name }}</option>
                      </b-form-select>

                      <label for="eGiftList">Gift List</label>
                      <b-form-select id="eGiftList" :plain="false" v-model="eGiftList" :state="$v.eGiftList.$error?false:null" @blur.native="$v.eGiftList.$touch">
                        <option :value="null">Please select</option>
                        <option v-for="t in giftLists" :value="t.Id" :key="`gift-list-${t.Id}`">{{ t.Name }}</option>
                      </b-form-select>
                      <div v-if="$v.eGiftList.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eGiftList.required">Gift list is required</div>
                      </div>

                      <label for="eExpireDays">Expire Days</label>
                      <b-form-input type="number" id="eExpireDays" placeholder="" v-model="eExpireDays" :state="$v.eExpireDays.$error?false:null" @focus.native="$v.eExpireDays.$touch"></b-form-input>
                      <div v-if="$v.eExpireDays.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eExpireDays.required">Expire Days is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eExpireDays.minValue">Must bigger than {{ $v.eExpireDays.$params.minValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eExpireDays.maxValue">Must less than {{ $v.eExpireDays.$params.maxValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eExpireDays.numeric">Must be number</div>
                      </div>

                      <label for="eQuantity">Quantity</label>
                      <b-form-input type="number" id="eQuantity" placeholder="" v-model="eQuantity" :state="$v.eQuantity.$error?false:null" @focus.native="$v.eQuantity.$touch"></b-form-input>
                      <div v-if="$v.eQuantity.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eQuantity.required">Ticket cQuantity is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eQuantity.minValue">Must bigger than {{ $v.eQuantity.$params.minValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eQuantity.maxValue">Must less than {{ $v.eQuantity.$params.maxValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eQuantity.numeric">Must be number</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="updateDraw" :disabled="$v.eDrawName.$error || $v.eDrawDisplayName.$error || $v.eGiftList.$error || $v.eExpireDays.$error">Update</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="closeEdit">Cancel</b-btn>
    </b-modal> -->
    <!-- <b-modal ref="createDraw" size="lg" header-bg-variant="primary" hide-footer title="Create Draw">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.cDrawName.$error && $v.cGiftList.$error && $v.cExpireDays.$error)">
                      <label for="cDrawName">Name</label>
                      <b-form-input type="text" id="cDrawName" placeholder="Enter Draw Name" v-model.trim="cDrawName" :state="$v.cDrawName.$error?false:null" @focus.native="$v.cDrawName.$touch"></b-form-input>
                      <div v-if="$v.cDrawName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cDrawName.required">Draw name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cDrawName.minLength">Must have at least {{ $v.cDrawName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cDrawName.maxLength">Must not exceed {{ $v.cDrawName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="cDrawDisplayName">Display Name</label>
                      <b-form-input type="text" id="cDrawDisplayName" placeholder="Enter Draw Name" v-model.trim="cDrawDisplayName" :state="$v.cDrawDisplayName.$error?false:null" @focus.native="$v.cDrawDisplayName.$touch"></b-form-input>
                      <div v-if="$v.cDrawDisplayName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cDrawDisplayName.required">Draw name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cDrawDisplayName.minLength">Must have at least {{ $v.cDrawDisplayName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cDrawDisplayName.maxLength">Must not exceed {{ $v.cDrawDisplayName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="cRuleList">Rule List</label>
                      <b-form-select id="cRuleList" :plain="false" v-model="cRuleList">
                        <option :value="null">Please select</option>
                        <option v-for="t in ruleLists" :value="t.Id" :key="`rule-list-${t.Id}`">{{ t.Name }}</option>
                      </b-form-select>

                      <label for="cGiftList">Gift List</label>
                      <b-form-select id="cGiftList" :plain="false" v-model="cGiftList" :state="$v.cGiftList.$error?false:null" @blur.native="$v.cGiftList.$touch">
                        <option :value="null">Please select</option>
                        <option v-for="t in giftLists" :value="t.Id" :key="`gift-list-${t.Id}`">{{ t.Name }}</option>
                      </b-form-select>
                      <div v-if="$v.cGiftList.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cGiftList.required">Gift List is required</div>
                      </div>

                      <label for="cExpireDays">Expire Days</label>
                      <b-form-input type="number" id="cExpireDays" placeholder="" v-model="cExpireDays" :state="$v.cExpireDays.$error?false:null" @focus.native="$v.cExpireDays.$touch"></b-form-input>
                      <div v-if="$v.cExpireDays.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cExpireDays.required">Expire Days is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cExpireDays.minValue">Must bigger than {{ $v.cExpireDays.$params.minValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cExpireDays.maxValue">Must less than {{ $v.cExpireDays.$params.maxValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cExpireDays.numeric">Must be number</div>
                      </div>

                      <label for="cQuantity">Ticket Quantity</label>
                      <b-form-input type="number" id="cQuantity" placeholder="" v-model="cQuantity" :state="$v.cQuantity.$error?false:null" @focus.native="$v.cQuantity.$touch"></b-form-input>
                      <div v-if="$v.cQuantity.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cQuantity.required">Ticket Quantity is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cQuantity.minValue">Must bigger than {{ $v.cQuantity.$params.minValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cQuantity.maxValue">Must less than {{ $v.cQuantity.$params.maxValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cQuantity.numeric">Must be number</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createDraw" :disabled="$v.cDrawName.$error || $v.cDrawDisplayName.$error || $v.cGiftList.$error || $v.cExpireDays.$error || $v.cQuantity.$error">Create Draw</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal">Cancel</b-btn>
    </b-modal> -->
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength, numeric, minValue, maxValue} = require('vuelidate/lib/validators')
  export default {
    name: 'draw-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        giftLists: [],
        ruleLists: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'DisplayName', label: 'Display Name'},
          {key: 'GiftListName', label: 'Gift List'},
          {key: 'RuleListName', label: 'Rule List'},
          {key: 'ExpireDays', label: 'Expire Days'},
          {key: 'Quantity', label: 'Ticket Quantity'}
          // {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        eDrawId: '',
        eDrawName: '',
        eDrawDisplayName: '',
        eGiftList: '',
        eRuleList: '',
        eExpireDays: 1,
        eQuantity: 1,
        cDrawName: '',
        cDrawDisplayName: '',
        cGiftList: '',
        cRuleList: '',
        cQuantity: 1,
        cExpireDays: 1
      }
    },
    validations: {
      eDrawName: { required, minLength: minLength(1), maxLength: maxLength(50) },
      eDrawDisplayName: { required, minLength: minLength(1), maxLength: maxLength(50) },
      eGiftList: { required },
      eExpireDays: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) },
      eQuantity: { required, numeric, minValue: minValue(1), maxValue: maxValue(50) },
      cDrawName: { required, minLength: minLength(1), maxLength: maxLength(50) },
      cDrawDisplayName: { required, minLength: minLength(1), maxLength: maxLength(50) },
      cGiftList: { required },
      cQuantity: { required, numeric, minValue: minValue(1), maxValue: maxValue(50) },
      cExpireDays: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) }
    },
    watch: {
      currentPage: function () {
        this.getAllDraws()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getAllDraws () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/draw/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.draws
          this.totalRows = response.data.draws.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllGiftLists () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/gift/list/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.giftLists = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllRuleLists () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/rule/list/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.ruleLists = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      updateDraw () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/draw/update', {'id': this.eDrawId, 'name': this.eDrawName, 'displayName': this.eDrawDisplayName, 'ruleList': this.eRuleList, 'giftList': this.eGiftList, 'expireDays': this.eExpireDays, 'quantity': this.eQuantity}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getAllDraws()
            this.closeEdit()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Draw Updated')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createDraw () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/draw/add', {'name': this.cDrawName, 'displayName': this.cDrawDisplayName, 'ruleList': this.cRuleList, 'giftList': this.cGiftList, 'expireDays': this.cExpireDays, 'quantity': this.cQuantity}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getAllDraws()
            this.hideModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Draw Added')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      editDraw (id) {
        this.items.forEach(item => {
          if (item.Id === id) {
            this.eDrawId = item.Id
            this.eDrawName = item.Name
            this.eDrawDisplayName = item.DisplayName
            this.eRuleList = item.RuleListId
            this.eGiftList = item.GiftListId
            this.eExpireDays = item.ExpireDays
            this.eQuantity = item.Quantity
          }
        })
        this.$refs.editDraw.show()
      },
      closeEdit () {
        this.$refs.editDraw.hide()
      },
      showModal () {
        this.reset()
        this.$refs.createDraw.show()
      },
      hideModal () {
        this.$refs.createDraw.hide()
      },
      reset () {
        this.cDrawName = ''
        this.cDrawDisplayName = ''
        this.cRuleList = ''
        this.cGiftList = ''
        this.cExpireDays = 1
        this.cQuantity = 1
      }
    },
    created () {
      this.getAllDraws()
      this.getAllGiftLists()
      this.getAllRuleLists()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/draw/DrawTable.vue